import { c as _c } from "react/compiler-runtime";
import { ArrowBackIos, Https } from "@mui/icons-material";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { Text, TextSize, TextWeight } from "../../../components";
import CarryLogo from "../../Navbar/carry-logo.jpg";
export const CheckoutHeader = t0 => {
  const $ = _c(12);
  const {
    isMobile
  } = t0;
  const t1 = `w-full h-16 border-b border-gray-200 flex justify-between items-center gap-2 px-4 ${isMobile ? "relative" : ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/koszyk" className="flex flex-1 items-center gap-1"><ArrowBackIos className="text-gray-700 !w-4 !h-4 -mt-[2px]" /><Text text="Koszyk" fontSize={TextSize.S} weight={TextWeight.SEMIBOLD} /></Link>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `flex flex-1 justify-center items-center ${isMobile ? "absolute left-1/2 -translate-x-1/2" : ""}`;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src={CarryLogo} alt="Carry Logo" width={90} height={32} />;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t3) {
    t5 = <Link href="/" className={t3}>{t4}</Link>;
    $[2] = t3;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isMobile) {
    t6 = !isMobile && <><Https className="text-gray-700 !w-4 !h-4 -mt-[2px]" /><Text text={"Bezpieczna p\u0142atno\u015B\u0107"} fontSize={TextSize.S} /></>;
    $[4] = isMobile;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <div className="flex flex-1 justify-end items-center gap-2">{t6}</div>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t1 || $[9] !== t5 || $[10] !== t7) {
    t8 = <div className={t1}>{t2}{t5}{t7}</div>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};